var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWhatsappIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "44px",
    height: "44px",
    viewBox: "0 0 44 44",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "whatsapp icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1.1-Vaitality-homes-page-Copy",
    transform: "translate(-1216.000000, -3599.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Footer",
    transform: "translate(0.000000, 3455.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "whatsapp-icon",
    transform: "translate(1216.000000, 144.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2-Copy-2",
    fill: "#FFFFFF",
    cx: 22,
    cy: 22,
    r: 22
  }), /*#__PURE__*/React.createElement("g", {
    id: "whatsapp",
    transform: "translate(11.000000, 11.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.00275,0 L10.99725,0 L10.99725,0 C4.932125,0 0,4.9335 0,11 C0,13.40625 0.7755,15.6365 2.094125,17.447375 L0.72325,21.533875 L4.951375,20.18225 C6.69075,21.3345 8.765625,22 11.00275,22 C17.067875,22 22,17.065125 22,11 C22,4.934875 17.067875,0 11.00275,0 Z",
    id: "Shape",
    fill: "#4CAF50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.403375,15.533375 C17.138,16.28275 16.08475,16.90425 15.244625,17.08575 C14.669875,17.208125 13.919125,17.30575 11.391875,16.258 C8.15925,14.91875 6.0775,11.633875 5.91525,11.42075 C5.759875,11.207625 4.609,9.681375 4.609,8.102875 C4.609,6.524375 5.410625,5.75575 5.73375,5.42575 C5.999125,5.154875 6.43775,5.031125 6.8585,5.031125 C6.994625,5.031125 7.117,5.038 7.227,5.0435 C7.550125,5.05725 7.712375,5.0765 7.9255,5.586625 C8.190875,6.226 8.837125,7.8045 8.914125,7.96675 C8.9925,8.129 9.070875,8.349 8.960875,8.562125 C8.85775,8.782125 8.767,8.87975 8.60475,9.06675 C8.4425,9.25375 8.2885,9.39675 8.12625,9.5975 C7.97775,9.772125 7.81,9.959125 7.997,10.28225 C8.184,10.5985 8.83025,11.653125 9.78175,12.500125 C11.009625,13.59325 12.005125,13.9425 12.36125,14.091 C12.626625,14.201 12.942875,14.174875 13.13675,13.968625 C13.382875,13.70325 13.68675,13.26325 13.996125,12.830125 C14.216125,12.519375 14.493875,12.480875 14.785375,12.590875 C15.082375,12.694 16.654,13.470875 16.977125,13.63175 C17.30025,13.794 17.513375,13.871 17.59175,14.007125 C17.66875,14.14325 17.66875,14.782625 17.403375,15.533375 Z",
    id: "Shape",
    fill: "#FAFAFA"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsappIcon);
export default __webpack_public_path__ + "static/media/whatsapp-icon.f5aaadf46e22f7affb193fdea46c5787.svg";
export { ForwardRef as ReactComponent };